// Vedaya AI Mock Data - Consistent with Product Brief

export const services = [
  {
    id: 'checkout-service',
    name: 'checkout-service',
    type: 'Web Service',
    technology: 'Java/Spring Boot',
    criticality: 'P1',
    criticalityLabel: 'Revenue-generating',
    environment: 'Production',
    team: 'Payments Team',
    techLead: 'Sarah Chen',
    onCall: '@payments-oncall',
    productOwner: 'Mike Johnson',
    infrastructure: {
      runsOn: 'EKS cluster (prod-us-east-1)',
      replicas: 12,
      cpu: '24 cores allocated',
      memory: '48 GB allocated'
    },
    dependencies: ['payments-db', 'redis-cache', 'stripe-api', 'auth-service'],
    dependents: ['frontend-web', 'mobile-api', 'order-service'],
    recentChanges: [
      { date: '2 days ago', action: 'Config update', by: 'Sarah Chen' },
      { date: '1 week ago', action: 'Version bump 2.4.1 to 2.4.2', by: 'CI/CD' },
      { date: '2 weeks ago', action: 'Scaled from 8 to 12 pods', by: 'Platform Team' }
    ]
  },
  {
    id: 'auth-service',
    name: 'auth-service',
    type: 'Web Service',
    technology: 'Node.js',
    criticality: 'P1',
    criticalityLabel: 'Authentication',
    environment: 'Production',
    team: 'Identity Team',
    techLead: 'Alex Rodriguez',
    onCall: '@identity-oncall',
    productOwner: 'Lisa Park',
    infrastructure: {
      runsOn: 'EKS cluster (prod-us-east-1)',
      replicas: 5,
      cpu: '10 cores allocated',
      memory: '20 GB allocated'
    },
    dependencies: ['user-db', 'session-cache', 'okta-api'],
    dependents: ['checkout-service', 'frontend-web', 'mobile-api'],
    recentChanges: [
      { date: '12 days ago', action: 'Manual scale 3 to 5 replicas', by: 'Ops Team' }
    ]
  },
  {
    id: 'order-service',
    name: 'order-service',
    type: 'Web Service',
    technology: 'Python/FastAPI',
    criticality: 'P1',
    criticalityLabel: 'Order Processing',
    environment: 'Production',
    team: 'Fulfillment Team',
    techLead: 'James Wilson',
    onCall: '@fulfillment-oncall',
    infrastructure: {
      runsOn: 'EKS cluster (prod-us-east-1)',
      replicas: 8,
      cpu: '16 cores allocated',
      memory: '32 GB allocated'
    },
    dependencies: ['payments-db', 'inventory-service'],
    dependents: ['frontend-web', 'mobile-api', 'warehouse-api']
  },
  {
    id: 'refund-service',
    name: 'refund-service',
    type: 'Web Service',
    technology: 'Java/Spring Boot',
    criticality: 'P2',
    criticalityLabel: 'Financial',
    environment: 'Production',
    team: 'Payments Team',
    techLead: 'Sarah Chen',
    onCall: '@payments-oncall',
    infrastructure: {
      runsOn: 'EKS cluster (prod-us-east-1)',
      replicas: 4,
      cpu: '8 cores allocated',
      memory: '16 GB allocated'
    },
    dependencies: ['payments-db', 'stripe-api'],
    dependents: ['support-portal', 'finance-api']
  },
  {
    id: 'frontend-web',
    name: 'frontend-web',
    type: 'Web Application',
    technology: 'React',
    criticality: 'P1',
    criticalityLabel: 'Customer-facing',
    environment: 'Production',
    team: 'Web Team',
    techLead: 'David Kim',
    onCall: '@web-oncall',
    infrastructure: {
      runsOn: 'CloudFront + S3',
      replicas: 'N/A (Static)',
      cpu: 'N/A',
      memory: 'N/A'
    },
    dependencies: ['checkout-service', 'auth-service', 'order-service'],
    dependents: ['customers']
  },
  {
    id: 'mobile-api',
    name: 'mobile-api',
    type: 'API Gateway',
    technology: 'Go',
    criticality: 'P1',
    criticalityLabel: 'Customer-facing',
    environment: 'Production',
    team: 'Mobile Team',
    techLead: 'Emily Zhang',
    onCall: '@mobile-oncall',
    infrastructure: {
      runsOn: 'EKS cluster (prod-us-east-1)',
      replicas: 10,
      cpu: '20 cores allocated',
      memory: '40 GB allocated'
    },
    dependencies: ['checkout-service', 'auth-service', 'order-service'],
    dependents: ['mobile-apps']
  },
  {
    id: 'session-manager',
    name: 'session-manager',
    type: 'Service',
    technology: 'Go',
    criticality: 'P1',
    criticalityLabel: 'Authentication',
    environment: 'Production',
    team: 'Identity Team',
    techLead: 'Alex Rodriguez',
    onCall: '@identity-oncall',
    infrastructure: {
      runsOn: 'EKS cluster (prod-us-east-1)',
      replicas: 6,
      cpu: '12 cores allocated',
      memory: '24 GB allocated'
    },
    dependencies: ['redis-cache'],
    dependents: ['auth-service']
  }
];

export const infrastructure = [
  {
    id: 'payments-db',
    name: 'payments-db',
    type: 'PostgreSQL RDS',
    status: 'Active',
    region: 'us-east-1',
    owner: 'Data Team',
    directDependents: ['checkout-service', 'order-service', 'refund-service'],
    transitiveDependents: ['frontend-web', 'mobile-api', 'support-portal', 'finance-api', 'warehouse-api']
  },
  {
    id: 'redis-cache-prod-3',
    name: 'redis-cache-prod-3',
    type: 'ElastiCache',
    status: 'Degraded',
    region: 'us-east-1',
    owner: 'Platform Team',
    directDependents: ['checkout-service', 'session-manager', 'cart-service']
  },
  {
    id: 'prod-us-east-1',
    name: 'prod-us-east-1',
    type: 'EKS Cluster',
    status: 'Active',
    region: 'us-east-1',
    owner: 'Platform Team'
  },
  {
    id: 'prod-vpc',
    name: 'prod-vpc',
    type: 'Security Group',
    status: 'Drift Detected',
    region: 'us-east-1',
    owner: 'Security Team'
  }
];

export const hardwareAssets = [
  { asset: 'db-server-01', type: 'Physical', age: '4.2 yrs', status: 'Active', owner: 'Data Team', region: 'us-east-1' },
  { asset: 'app-server-12', type: 'Physical', age: '3.8 yrs', status: 'Active', owner: 'Platform', region: 'us-east-1' },
  { asset: 'legacy-web-03', type: 'Physical', age: '5.1 yrs', status: 'Active', owner: 'Web Team', region: 'us-east-1' }
];

export const saasApps = [
  { application: 'Figma', licenses: 200, active: 67, utilization: 34, annualCost: 36000 },
  { application: 'Notion', licenses: 500, active: 234, utilization: 47, annualCost: 48000 },
  { application: 'Miro', licenses: 150, active: 41, utilization: 27, annualCost: 18000 }
];

export const lifecycleEvents = [
  { type: 'END OF SUPPORT', items: [
    { name: 'Windows Server 2016', count: '23 instances', date: 'Jan 12, 2026' },
    { name: 'PostgreSQL 12', count: '8 instances', date: 'Feb 14, 2026' }
  ]},
  { type: 'LICENSE RENEWALS', items: [
    { name: 'Datadog Enterprise', date: 'Feb 1', cost: '$340,000' },
    { name: 'GitHub Enterprise', date: 'Feb 15', cost: '$89,000' },
    { name: 'Snowflake', date: 'Mar 1', cost: '$520,000' }
  ]},
  { type: 'HARDWARE REFRESH', items: [
    { name: '12 servers past 3-year cycle', date: 'See asset report' }
  ]}
];

export const teams = [
  { id: 'payments', name: 'Payments Team', lead: 'Sarah Chen', onCall: '@payments-oncall', slack: '#payments-team' },
  { id: 'identity', name: 'Identity Team', lead: 'Alex Rodriguez', onCall: '@identity-oncall', slack: '#identity-team' },
  { id: 'platform', name: 'Platform Team', lead: 'Chris Martinez', onCall: '@platform-oncall', slack: '#platform-team' },
  { id: 'security', name: 'Security Team', lead: 'Jordan Lee', onCall: '@security-oncall', slack: '#security-team' },
  { id: 'data', name: 'Data Team', lead: 'Pat Thompson', onCall: '@data-oncall', slack: '#data-team' },
  { id: 'web', name: 'Web Team', lead: 'David Kim', onCall: '@web-oncall', slack: '#web-team' },
  { id: 'mobile', name: 'Mobile Team', lead: 'Emily Zhang', onCall: '@mobile-oncall', slack: '#mobile-team' }
];

export const compliance = {
  frameworks: [
    { name: 'SOC 2 Type II', score: 87, issues: 3, status: 'controls need attention' },
    { name: 'PCI DSS', score: 94, issues: 1, status: 'finding open' },
    { name: 'HIPAA', score: 91, issues: 2, status: 'controls need attention' },
    { name: 'GDPR', score: 85, issues: 4, status: 'items need review' }
  ],
  findings: [
    { framework: 'PCI', severity: 'warning', description: 'new-analytics-service has path to cardholder data', added: '3 days ago', status: 'Not in PCI scope' },
    { framework: 'SOC2', severity: 'warning', description: '3 services missing encryption at rest', items: 'staging-db, test-cache, dev-storage' },
    { framework: 'GDPR', severity: 'warning', description: 'User data retained beyond policy in 2 systems', items: 'legacy-analytics, old-crm-sync' }
  ]
};

export const costData = {
  infrastructure: [
    { item: 'checkout-service (EKS)', cost: 12400 },
    { item: 'payments-db (RDS)', cost: 18200 },
    { item: 'redis-cache (ElastiCache)', cost: 4100 },
    { item: 'Load balancer', cost: 2800 },
    { item: 'Data transfer', cost: 9730 }
  ],
  thirdParty: [
    { item: 'Stripe fees', cost: 28000 },
    { item: 'Fraud detection (Sift)', cost: 4500 },
    { item: 'Address validation', cost: 2000 }
  ],
  people: [
    { item: 'Payments Team (4 engineers)', cost: 70000 },
    { item: 'On-call burden (estimated)', cost: 15000 }
  ],
  optimizations: [
    { item: 'payments-db: Oversized by 40%', savings: 7200 },
    { item: 'Reserved instances: 67% on-demand', savings: 8400 },
    { item: 'Stripe: Volume discount available', savings: 5000 }
  ],
  totals: {
    infrastructure: 47230,
    thirdParty: 34500,
    people: 85000,
    total: 166730,
    costPerTransaction: 0.034,
    revenuePerTransaction: 47.20,
    marginContribution: 99.9,
    potentialSavings: 20600
  }
};

export const configDrift = [
  {
    service: 'auth-service',
    expected: '3 replicas (per Terraform)',
    actual: '5 replicas (manual scale)',
    driftedAgo: '12 days ago'
  },
  {
    service: 'prod-vpc security group',
    expected: 'Port 443 only',
    actual: 'Port 443, 8080 open',
    driftedAgo: '3 days ago',
    changedBy: 'deploy-bot (CI/CD)'
  }
];

export const connectors = [
  { id: 'aws', name: 'AWS', category: 'Infrastructure', icon: 'cloud', connected: true },
  { id: 'gcp', name: 'GCP', category: 'Infrastructure', icon: 'cloud', connected: false },
  { id: 'azure', name: 'Azure', category: 'Infrastructure', icon: 'cloud', connected: false },
  { id: 'kubernetes', name: 'Kubernetes', category: 'Infrastructure', icon: 'box', connected: true },
  { id: 'datadog', name: 'Datadog', category: 'Operations', icon: 'activity', connected: true },
  { id: 'pagerduty', name: 'PagerDuty', category: 'Operations', icon: 'bell', connected: true },
  { id: 'github', name: 'GitHub', category: 'Development', icon: 'git-branch', connected: true },
  { id: 'okta', name: 'Okta', category: 'Business', icon: 'shield', connected: true },
  { id: 'terraform', name: 'Terraform', category: 'Development', icon: 'layers', connected: true },
  { id: 'jira', name: 'Jira', category: 'Operations', icon: 'clipboard', connected: false },
  { id: 'servicenow', name: 'ServiceNow', category: 'Operations', icon: 'server', connected: false }
];

export const recentSignals = [
  { type: 'alert', title: 'Redis latency alert', description: 'redis-cache-prod-3 latency at 450ms', time: '2 min ago', severity: 'critical' },
  { type: 'drift', title: 'Security group drift', description: 'prod-vpc has unauthorized port open', time: '3 days ago', severity: 'warning' },
  { type: 'renewal', title: 'Upcoming renewals', description: '3 licenses renewing in 90 days', time: 'Next 90 days', severity: 'info' }
];

export const incident = {
  id: 'INC-2026-0142',
  alert: 'High latency on redis-cache-prod-3',
  time: '2 minutes ago',
  service: 'redis-cache-prod-3',
  serviceType: 'ElastiCache',
  status: 'Degraded',
  latency: { current: '450ms', baseline: '12ms' },
  directImpact: [
    { service: 'checkout-service', criticality: 'P1', note: 'revenue' },
    { service: 'session-manager', criticality: 'P1', note: 'auth' },
    { service: 'cart-service', criticality: 'P2', note: '' }
  ],
  transitiveImpact: [
    'frontend-web (via checkout-service)',
    'mobile-api (via checkout-service)',
    'auth-service (via session-manager)'
  ],
  customerImpact: '~12,000 users may experience slow checkout',
  recentChanges: [
    {
      time: '3 hours ago',
      change: 'Redis config change (maxmemory-policy)',
      by: '@john-smith via Terraform',
      pr: '#4521 "Optimize cache eviction"'
    }
  ],
  recommendations: [
    { action: 'Roll back Redis config', confidence: 'high' },
    { action: 'Page: @payments-oncall (checkout owner)', confidence: '' },
    { action: 'Page: @john-smith (change author)', confidence: '' }
  ]
};

export const soc2Evidence = {
  title: 'SOC 2 EVIDENCE PACKAGE: ACCESS CONTROLS',
  generated: 'January 10, 2026',
  period: 'Q4 2025',
  control: 'CC6.1 - Logical Access',
  evidence: [
    {
      title: 'All production systems require SSO (Okta)',
      coverage: '100% (347/347 systems)',
      exceptions: 0
    },
    {
      title: 'MFA enabled for all users',
      coverage: '100% (1,247 users)',
      exceptions: 0
    },
    {
      title: 'Access reviews completed quarterly',
      lastReview: 'December 15, 2025',
      revocations: '23 users (termed employees)'
    },
    {
      title: 'Privileged access limited',
      details: [
        'Production admin: 12 users',
        'Database admin: 8 users',
        'All with justification on file'
      ]
    }
  ]
};

export const piiLineage = {
  collectionPoints: [
    'signup-form (frontend-web)',
    'mobile-app (mobile-api)',
    'support-portal (zendesk integration)'
  ],
  primaryStorage: 'user-db (PostgreSQL RDS, encrypted)',
  processing: [
    { category: 'PROCESSING', items: ['auth', 'billing', 'support'] },
    { category: 'ANALYTICS', items: ['snowflake (masked)', 'looker'] },
    { category: 'MARKETING', items: ['hubspot (email only)', 'mailchimp'] }
  ],
  retention: [
    { system: 'user-db', policy: 'Active + 7 years (legal requirement)' },
    { system: 'snowflake', policy: '2 years (masked after 90 days)' },
    { system: 'hubspot', policy: 'Until unsubscribe + 30 days' }
  ],
  findings: [
    { issue: 'legacy-analytics has unmasked PII', severity: 'violation' }
  ]
};

export const authFlowOwnership = {
  components: [
    { service: 'frontend-web', owner: 'Web Team' },
    { service: 'auth-service', owner: 'Identity Team' },
    { service: 'user-db', owner: 'Data Team' },
    { service: 'session-cache', owner: 'Platform Team' }
  ],
  primaryOwner: {
    team: 'Identity Team',
    lead: 'Alex Rodriguez',
    onCall: '@identity-oncall',
    slack: '#identity-team'
  },
  stakeholders: [
    'Web Team (frontend integration)',
    'Data Team (user database)',
    'Platform Team (session infrastructure)',
    'Security Team (auth policies)'
  ],
  escalation: [
    '@identity-oncall (PagerDuty)',
    'Alex Rodriguez (Identity Lead)',
    'VP Engineering (if P1 > 30 min)'
  ]
};

export const cannedQueries = {
  'servers in us-east-1 older than 3 years': 'hardwareAssets',
  'configuration drift': 'configDrift',
  'who owns the authentication': 'authOwnership',
  'soc 2 evidence': 'soc2Evidence',
  'high latency': 'incident',
  'redis': 'incident',
  'checkout flow cost': 'costData',
  'saas with less than 50% utilization': 'saasUnderutilized',
  'underutilized': 'saasUnderutilized'
};